import React, { useEffect, useState } from "react";
import { Flex, Rate, message } from "antd";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";
import TextArea from "antd/es/input/TextArea";

const ReviewModal = ({
  isOpen,
  userId,
  guideId,
  title = "Leave Your Review",
  description = "How was your session experience? Your feedback helps us improve future sessions.",
  btnLabel = "Submit",
  onSubmit = () => {},
  onCancelClick = () => {},
}) => {
  const [rating, setRating] = useState(4);
  const [review, setReview] = useState("");

  const handleSubmit = () => {
    if (rating < 1) {
      message.error("Please select at least one star");
      return;
    }
    if (!review.trim()) {
      message.error("Please write your review");
      return;
    }
    onSubmit({ userId, guideId, rating, review });
  };

  // reset the state on close
  useEffect(() => {
    if (!isOpen) {
      setRating(4);
      setReview("");
    }
  }, [isOpen]);

  return (
    <ModalComponent isOpen={isOpen} width={400} onCancelClick={onCancelClick} closable={true}>
      <Flex vertical gap="1rem" align="center">
        <div className="text-center">
          <h2 className="body-b2" style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>
            {title}
          </h2>
          <p className="body-b3">{description}</p>
        </div>

        {/* Star Rating */}
        <Rate value={rating} onChange={setRating} count={5} className="review-star" />

        {/* Review Textarea */}
        <TextArea
          className="w-full border rounded p-2"
          rows={4}
          placeholder="Write your review..."
          value={review}
          onChange={(e) => setReview(e.target.value)}
        />

        {/* Submit Button */}
        <ButtonComponent
          style={{ width: "100%" }}
          label={btnLabel}
          type="primary"
          onClick={handleSubmit}
          disabled={rating < 1 || !review.trim()}
        />
        {/* Cancel */}
        <ButtonComponent
          style={{ width: "100%", border: "1px solid #E5E5E5", background: "#fff" }}
          label="Cancel"
          type="text"
          onClick={onCancelClick}
        />
      </Flex>
    </ModalComponent>
  );
};

export default ReviewModal;
